import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/home/Home";
import Login from "../pages/login/Login";
import About from "../pages/about/About";
import Menu from "../pages/menu/Menu";
import NotFound from "../pages/not-found/NotFound";
import Dish from "../pages/detailed-dish/Dish";
import Reservation from "../pages/reservation/Reservation";
import Cart from "../pages/cart/Cart";
import User from "../pages/user/User";

const MainRoute = ()=>{
    return(
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/user" element={<User/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/menu" element={<Menu/>}/>
            <Route path="/reservation" element={<Reservation/>}/>
            <Route path="/meal/">
                <Route path=":id" element={<Dish/>}/>
                <Route path="" element={<NotFound/>}/>
            </Route>
            <Route path="/cart" element={<Cart/>}/>
            <Route path="/*" element={<NotFound/>}/>
        </Routes>
    )
}
export default MainRoute;